import { gsap, Sine, Power0, Power1, Power2, Power3, Power4 } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollToPlugin)
gsap.registerPlugin(ScrollTrigger);

window.addEventListener('load', function(){
  const heroTitle = document.querySelector(".guideHero-ttl");
  const heroBg = document.querySelector(".guideHeroBg");
  const tlHeroTop = gsap.timeline();

  tlHeroTop
  .to(heroTitle, { duration: 1, autoAlpha: 1 , ease: Sine.easeOut } )
  .to(heroTitle, { duration: 1.3, y: "0%" , ease: "bounce.out" }, "-=0.8" )
  .to(heroBg, { duration: 1.5, autoAlpha: 1 ,  ease: Sine.easeOut }, "-=0.3" );

  tlHeroTop.play();

});

// SCROLL TRIGGER
// =======================================================

const wrapper = document.querySelector(".guide-wrapper");

ScrollTrigger.create({
  trigger: ".sec08",
  start: "top bottom",
  end: `bottom bottom`,
  onEnter: function() {
    wrapper.classList.add("is-scroll");
  },
  onLeave: function() {
  },
  onEnterBack: function() {
    wrapper.classList.remove("is-scroll");
  },
  onLeaveBack: function() {
  },
});

const fadeInAnimElements = document.querySelectorAll('[data-anim="fadeIn"]');
fadeInAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.7,
    autoAlpha: 1,
    ease: Sine.easeInOut,
    scrollTrigger: {
      trigger: element,
      start: "top 75%",
    }
  })  
});

const zoomInAnimElements = document.querySelectorAll('[data-anim="zoomIn"]');
zoomInAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 1.2,
    scale: 1,
    autoAlpha: 1,
    ease: "bounce.out",
    scrollTrigger: {
      trigger: element,
      start: "top 75%",
      end: "bottom bottom",
    }
  })  
});

const zoomInBlurAnimElements = document.querySelectorAll('[data-anim="zoomInBlur"]');
zoomInBlurAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.7,
    scale: 1,
    filter: "blur(0px)",
    ease: Sine.easeInOut,
    scrollTrigger: {
      trigger: element,
      start: "top 75%",
      end: "bottom bottom",
    }
  })  
});

const blurAnimElements = document.querySelectorAll('[data-anim="blur"]');
blurAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.7,
    filter: "blur(0px)",
    ease: Sine.easeInOut,
    scrollTrigger: {
      trigger: element,
      start: "top 60%",
      end: "bottom bottom",
    }
  })  
});


const fadeInRightAnimElements = document.querySelectorAll('[data-anim="fadeInRight"]');

fadeInRightAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.8,
    autoAlpha: 1,
    x: 0,
    ease: "power1.out",
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      end: "bottom bottom",
    }
  })  
});

const fadeInLeftAnimElements = document.querySelectorAll('[data-anim="fadeInLeft"]');

fadeInLeftAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.8,
    autoAlpha: 1,
    x: 0,
    ease: "power1.out",
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      end: "bottom bottom",
    }
  })  
});


const fadeInUpAnimElements = document.querySelectorAll('[data-anim="fadeInUp"]');

fadeInUpAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.5,
    autoAlpha: 1,
    y: 0,
    ease: Sine.easeInOut,
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      end: "bottom bottom",
    }
  })  
});

